import type { Block, BlockType } from "../../api/types.ts";

/**
 * The palette, and the defaults a newly added block starts with.
 *
 * Deliberately small. A constrained set of blocks is what keeps the rendered
 * output predictable in Outlook; the per-block code view is the escape hatch
 * for anything this does not cover.
 */
export const BLOCK_LABELS: Record<BlockType, string> = {
  heading: "Heading",
  text: "Text",
  image: "Image",
  button: "Button",
  divider: "Divider",
  spacer: "Spacer",
  footer: "Footer",
};

export const BLOCK_ORDER: BlockType[] = [
  "heading",
  "text",
  "image",
  "button",
  "divider",
  "spacer",
  "footer",
];

const DEFAULT_PROPS: Record<BlockType, Record<string, unknown>> = {
  heading: { text: "A heading", level: 2, align: "left" },
  text: { html: "<p>Write something here.</p>", align: "left", fontSize: 15 },
  image: { src: "", alt: "", width: 552 },
  button: { label: "Read more", href: "https://", bg: "#7da51a", fg: "#ffffff" },
  divider: { color: "#e5e5e5" },
  spacer: { height: 24 },
  footer: { companyAddress: "Your company, 1 Example Street", showUnsubscribe: true },
};

export function newBlock(type: BlockType): Block {
  return { id: crypto.randomUUID(), type, props: { ...DEFAULT_PROPS[type] } };
}

/**
 * A starter document with a footer already in place. An unsubscribe link is
 * required on bulk mail, and it is far easier to notice a footer you do not
 * want than one you forgot.
 */
export function starterDocument() {
  return {
    version: 1 as const,
    blocks: [newBlock("heading"), newBlock("text"), newBlock("footer")],
    theme: {
      fontFamily: "Inter, Helvetica, Arial, sans-serif",
      textColor: "#262626",
      backgroundColor: "#f5f5f5",
      containerWidth: 600,
      linkColor: "#7da51a",
    },
  };
}
